import { Label, Text } from "@fluentui/react";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

interface IFinishPage {
  wizardState: any;
}

export const Finish: FC<IFinishPage> = (props) => {
  const { subscription } = props.wizardState;

  return (
    <>
      <Label>
        <FormattedMessage
          id="azure-subscription-wizard-messages.finish.tenant-settings"
          defaultMessage="Azure settings"
        />
      </Label>
      <Text block>
        <FormattedMessage
          id="azure-subscription-wizard-messages.finish.tenant-name"
          defaultMessage="Subscription: {name}"
          values={{ name: subscription?.name || "?" }}
        />
      </Text>
    </>
  );
};
